// illustrations will be added to the icons repo soon, but for now we'll use this one
export const EmptyStateIllustration = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="184"
        height="100"
        viewBox="0 0 184 100"
        fill="none"
    >
        <g filter="url(#filter0_d_70_21310)">
            <rect
                x="29.0902"
                y="29.0903"
                width="125.591"
                height="34.3573"
                rx="17.1787"
                fill="#FFFEFE"
            />
        </g>
        <rect
            opacity="0.2"
            x="50.4237"
            y="38.0037"
            width="16.5304"
            height="3.65185"
            rx="1.82593"
            transform="rotate(90 50.4237 38.0037)"
            fill="url(#paint0_linear_70_21310)"
            stroke="white"
            strokeWidth="0.226064"
        />
        <path
            opacity="0.2"
            // eslint-disable-next-line max-len
            d="M108.382 46.3823C119.057 46.3824 127.711 55.0363 127.711 65.7114C127.711 69.8406 126.416 73.6667 124.21 76.8071L124.157 76.8853L124.223 76.9526L132.823 85.5522C134.093 86.8226 134.093 88.8815 132.823 90.1519C131.552 91.4222 129.493 91.4222 128.223 90.1519L119.623 81.5522L119.556 81.4858L119.478 81.5396C116.338 83.7451 112.511 85.0405 108.382 85.0405C97.7071 85.0405 89.0532 76.3865 89.0531 65.7114C89.0531 55.0362 97.707 46.3823 108.382 46.3823ZM108.382 52.8882C101.3 52.8882 95.559 58.6292 95.559 65.7114C95.5591 72.7935 101.3 78.5347 108.382 78.5347C115.464 78.5346 121.205 72.7935 121.205 65.7114C121.205 58.6293 115.464 52.8883 108.382 52.8882Z"
            fill="url(#paint1_linear_70_21310)"
            stroke="white"
            strokeWidth="0.226064"
        />
        <defs>
            <filter
                id="filter0_d_70_21310"
                x="-4.19617e-05"
                y="8.01086e-05"
                width="183.771"
                height="92.5379"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="14.5451" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.15 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_70_21310"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_70_21310"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_70_21310"
                x1="50.461"
                y1="39.9464"
                x2="55.2946"
                y2="32.364"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="#AAC2FF"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_70_21310"
                x1="107.935"
                y1="47.988"
                x2="132.171"
                y2="94.3469"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="1"
                    stopColor="#AAC2FF"
                />
            </linearGradient>
        </defs>
    </svg>
);
